export const holdingsEndpoints = (builder) => ({
    getPositions: builder.query({
        query: (instrumentId) => ({ url: `/positions?instrumentId=${instrumentId}`, method: 'get' }),
    }),
    payoutDividends: builder.mutation({
        query: (dividend) => ({ url: `/positions/dividends`, method: 'post', body: dividend }),
    }),
    payoutSelectiveDividends: builder.mutation({
        query: ({ assetId, amountPerShare, qualificationDate, users }) => (
            {
                url: `/positions/dividends/selective`,
                method: 'post',
                body: {
                    assetId, amountPerShare, qualificationDate, users
                }
            }
        ),
    }),
    appendBonusShareHistory: builder.mutation({
        query: ({ instrumentId, ...data }) => ({ url: `/positions/bonus-shares/${instrumentId}`, method: 'post', body: data }),
        invalidatesTags: ['Bonus Shares']
    }),
    payBonusShares: builder.mutation({
        query: (bonusShareId) => ({ url: `/positions/bonus-shares/${bonusShareId}/pay`, method: 'post' }),
        invalidatesTags: ['Bonus Shares']
    }),
    paySelectiveBonusShares: builder.mutation({
        query: ({ bonusShareId, users }) => (
            {
                url: `/positions/bonus-shares/${bonusShareId}/selective`,
                method: 'post',
                body: { users }
            }
        ),
        invalidatesTags: ['Bonus Shares']
    }),
    getBonusSharesHistory: builder.query({
        query: (instrumentId) => ({ url: `/positions/bonus-shares/${instrumentId}`, method: 'get' }),
        providesTags: ['Bonus Shares'],
    }),
    getEligibleShares: builder.query({
        query: ({ instrumentId, qualificationDate, accountId, userId }) => {
            const params = [
                `instrumentId=${instrumentId}`,
                `qualificationDate=${qualificationDate}`,
                accountId ? `accountId=${accountId}` : null,
                userId ? `userId=${userId}` : null,
            ].filter(Boolean).join("&");
            return { url: `/positions/eligible-shares?${params}`, method: 'get' };
        },
        providesTags: ['Eligible Shares'],
    }),
    getDividendAnnouncements: builder.query({
        query: ({ page = 1, size = 20 } = {}) => ({ url: `/positions/dividend/announcements?page=${page}&size=${size}`, method: 'get' }),
        providesTags: ['Dividend Announcements'],
    }),
    createDividendAnnouncement: builder.mutation({
        query: (data) => ({ url: `/positions/dividend/announcements`, method: 'post', body: data }),
        invalidatesTags: ['Dividend Announcements'],
    }),
    generateDividendBatch: builder.mutation({
        query: ({ announcementId, userGroup, instrumentId, qualificationDate, dividendPerShare }) => ({
            url: `/positions/dividend/batches/generate`,
            method: 'post',
            body: {
                announcementId,
                ...(instrumentId ? { instrumentId } : {}),
                ...(qualificationDate ? { qualificationDate } : {}),
                ...(dividendPerShare !== undefined && dividendPerShare !== null ? { dividendPerShare } : {}),
                ...(userGroup ? { userGroup } : {}),
            }
        }),
        invalidatesTags: ['Dividend Batches'],
    }),
    getDividendBatches: builder.query({
        query: ({ page = 1, size = 20 } = {}) => ({ url: `/positions/dividend/batches?page=${page}&size=${size}`, method: 'get' }),
        providesTags: ['Dividend Batches'],
    }),
    getDividendBatch: builder.query({
        query: (batchId) => ({ url: `/positions/dividend/batches/${batchId}`, method: 'get' }),
        providesTags: ['Dividend Batches'],
    }),
    updateDividendBatchRecord: builder.mutation({
        query: ({ batchId, recordId, dividendAmount, adjustmentReason }) => ({
            url: `/positions/dividend/batches/${batchId}/records/${recordId}`,
            method: 'patch',
            body: {
                dividendAmount,
                adjustmentReason,
            }
        }),
        invalidatesTags: ['Dividend Batches'],
    }),
    approveDividendBatch: builder.mutation({
        query: (batchId) => ({ url: `/positions/dividend/batches/${batchId}/approve`, method: 'post' }),
        invalidatesTags: ['Dividend Batches'],
    }),
    executeDividendBatch: builder.mutation({
        query: (batchId) => ({ url: `/positions/dividend/batches/${batchId}/execute`, method: 'post' }),
        invalidatesTags: ['Dividend Batches'],
    }),
    recallDividendBatch: builder.mutation({
        query: (batchId) => ({ url: `/positions/dividend/batches/${batchId}/recall`, method: 'post' }),
        invalidatesTags: ['Dividend Batches'],
    }),
    getDividendBatchAudit: builder.query({
        query: (batchId) => ({ url: `/positions/dividend/batches/${batchId}/audit`, method: 'get' }),
        providesTags: ['Dividend Batches'],
    }),
})
